<template>
  <div class="container">
      <Introduction v-if="index=='0'"></Introduction>
      <Get-Start v-if="index=='1-1'"></Get-Start>
      <Faxchain-Platform-Overview v-if="index=='1-2'"></Faxchain-Platform-Overview>
      <Faxchain-Blockchain-Consensus v-if="index=='1-3'"></Faxchain-Blockchain-Consensus>
      <Faxchain-Bridge v-if="index=='1-4'"></Faxchain-Bridge>
      <Faxchain-Go v-if="index=='2-1'"></Faxchain-Go>
      <How-To-Use-Ledger v-if="index=='2-2'"></How-To-Use-Ledger>
      <Overview v-if="index=='2-3'"></Overview>
      <Staking v-if="index=='2-4'"></Staking>
      <Faxchain-Transaction-Fee v-if="index=='2-5'"></Faxchain-Transaction-Fee>
      <testnetUpdate v-if="index=='2-6'"></testnetUpdate>
      <Tools-Overview v-if="index=='3-1'"></Tools-Overview>
      <Public-API v-if="index=='3-2'"></Public-API>
      <Cryptographic-Primitives v-if="index=='3-3'"></Cryptographic-Primitives>
      <Network-Protocol v-if="index=='4-1'"></Network-Protocol>
      <Platform-Transaction-Format v-if="index=='4-2'"></Platform-Transaction-Format>
      <Serialization-Primitives v-if="index=='4-3'"></Serialization-Primitives>
      <basicConcepts v-if="index=='5-1'"/>
      <feeModel v-if="index=='5-2'"/>
      <onchainGovernance v-if="index=='5-3'"/>
      <matchingSystem v-if="index=='5-4'"/>
      <sentryNode v-if="index=='5-5'"/>
      <twoFormatAddress v-if="index=='5-6'"/>
      <shareProfit v-if="index=='5-7'"/>
      <genesisFile v-if="index=='6-1'"/>
      <faxClient v-if="index=='6-2'"/>
      <serviceProviders v-if="index=='6-3'"/>
      <API v-if="index=='7-1'"/>
      
  </div>
</template>

<script>
import Introduction from '@/components/introduction.vue'
import GetStart from '@/components/getStart.vue'
import FaxchainPlatformOverview from '@/components/FaxchainPlatformOverview.vue'
import FaxchainBlockchainConsensus from '@/components/FaxchainBlockchainConsensus.vue'
import Staking from '@/components/Staking.vue'
import FaxchainTransactionFee from '@/components/FaxchainTransactionFee.vue'
import FaxchainBridge from '@/components/FaxchainBridge.vue'
import HowToUseLedger from '@/components/HowToUseLedger.vue'
import FaxchainGo from '@/components/FaxchainGo.vue'
import Overview from '@/components/Overview.vue'
import ToolsOverview from '@/components/ToolsOverview.vue'
import PublicAPI from '@/components/PublicAPI.vue'
import CryptographicPrimitives from '@/components/CryptographicPrimitives.vue'
import NetworkProtocol from '@/components/NetworkProtocol.vue'
import SerializationPrimitives from '@/components/SerializationPrimitives.vue'
import PlatformTransactionFormat from '@/components/PlatformTransactionFormat.vue'
import basicConcepts from '@/components/basicConcepts.vue'
import feeModel from '@/components/feeModel.vue'
import onchainGovernance from '@/components/onchainGovernance.vue'
import matchingSystem from '@/components/matchingSystem.vue'
import sentryNode from '@/components/sentryNode.vue'
import twoFormatAddress from '@/components/twoFormatAddress.vue'
import genesisFile from '@/components/genesisFile.vue'
import faxClient from '@/components/faxClient.vue'
import serviceProviders from '@/components/serviceProviders.vue'
import testnetUpdate from '@/components/testnetUpdate.vue'
import shareProfit from '@/components/shareProfit.vue'
import API from '@/components/API.vue'
export default {
    name: 'Main',
    components: {
        Introduction,
        GetStart,
        FaxchainPlatformOverview,
        FaxchainBlockchainConsensus,
        Staking,
        FaxchainTransactionFee,
        FaxchainBridge,
        HowToUseLedger,
        FaxchainGo,
        Overview,
        ToolsOverview,
        PublicAPI,
        CryptographicPrimitives,
        NetworkProtocol,
        SerializationPrimitives,
        PlatformTransactionFormat,
        basicConcepts,
        feeModel,
        onchainGovernance,
        matchingSystem,
        sentryNode,
        twoFormatAddress,
        genesisFile,
        faxClient,
        serviceProviders,
        testnetUpdate,
        shareProfit,
        API,
    },
    props: {
        index: String
    }

}
</script>

<style lang="sass">
@media screen and (min-width:980px)
  .container
    display: flex
    .content
      width: 78%
      padding: 10px 6px
      .p1
        padding: 20px 0
        font-size: 50px
        font-weight: 700
        line-height: 60px
        padding-top: 80px!important
        margin-top: -80px!important
      .p2
        padding: 20px 0
        font-size: 35px
        font-weight: 700
        line-height: 40px
        padding-top: 80px!important
        margin-top: -80px!important
      .p4
        padding: 20px 0
        font-size: 26px
        font-weight: 700
        line-height: 30px
        padding-top: 80px!important
        margin-top: -80px!important
      .p3
        line-height: 25px
        padding-bottom: 15px
    .anchor2
      display: none
    .wrapper
      width: 22%
      .anchor1
        margin: 70px 0
        position: fixed!important
        top: 20!important
        right: 10!important
        padding: 0px 15px 0!important
        padding-right: 0
        width: 15%
        color: #525860
        font-size: 14px
        border-left: 1px solid #DADDE1
        z-index: 9999!important
        background: #fff
        .s1
          margin: 10px 0
          line-height: 20px
          cursor: pointer
          // word-break: break-all
          word-wrap: wrap
        .active  
          color: #7549A9
        a
          color: #525860
        a:hover
          color: #7549A9
          font-size: 15px
        .subAnchor
          padding: 0 15px
          .s2
            margin: 10px 0
            line-height: 20px
            cursor: pointer
            // word-break: break-all
            word-wrap: wrap

@media screen and (max-width:980px)
  .container
    .introduction
      padding: 10px 6px
      .p1
        font-size: 50px
        font-weight: 700
        line-height: 70px
      .p2
        font-size: 35px
        font-weight: 700
        line-height: 80px
        padding-top: 80px!important
        margin-top: -80px!important
      .p3
        line-height: 30px
        // word-break: break-all
        word-wrap: wrap
      .p4
        // word-break: break-all
        word-wrap: wrap
        padding-top: 80px!important
        margin-top: -80px!important

</style>